import { useSelector } from "react-redux";
/**
 * @category Hooks
 */
export const useGlobalStoreState = () => {
    return useSelector((state) => state.globalStore);
};
export default useGlobalStoreState;
//# sourceMappingURL=useGlobalStoreState.js.map